var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"spinner",attrs:{"role":"status"}},[_c('div',{staticClass:"spinner-container"},[_c('LoaderKaik')],1),_c('span',{staticClass:"visually-hidden"},[_vm._v("Cargando")])])
}
var staticRenderFns = []

export { render, staticRenderFns }